import { Artefact } from "@/lib/artefacts";
import { fetchMarkdownArtefact } from "@/lib/artefacts/markdown";
import { type Task } from "@/stores/task-store";

export async function getEvidenceInstructionsArtefact(
    task: Task,
    name: string,
    signal?: AbortSignal,
    query?: URLSearchParams
): Promise<Artefact<"text/markdown">> {
    return fetchMarkdownArtefact(
        task,
        task.evidence_instructions,
        name,
        "_evidence_instructions",
        signal,
        query
    );
}
